export enum AUTH_ERROR {
  missing_ods_code = "missing_ods_code",
  something_went_wrong = "something_went_wrong",
  user_session_not_found = "user_session_not_found",
}
